import angular from 'angular'

import { RegisterOpenReminderComponent } from './register-open-reminder.component'

angular
  .module('webregister.components')
  .component('registerOpenReminder', RegisterOpenReminderComponent)
